import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n";

export default function BetalingGeannuleerd() {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="payment-cancelled">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <XCircle className="mx-auto h-14 w-14 text-amber-500" />
        <h1 className="mt-5 font-display text-2xl font-bold text-slate-900">{t("payment_cancel_title")}</h1>
        <p className="mt-2 text-sm text-slate-600">{t("payment_cancel_text")}</p>
        <Link to="/" className="mt-6 inline-block text-sm font-semibold text-sky-700 hover:underline">{t("back")}</Link>
      </div>
    </div>
  );
}
